export const defaultCollaboratorCategoryOptions = {
  'Production & Talent Services': [
    'Production House',
    'Music Label',
    'Event Management Company',
    'Talent Management Company',
    'Event Organizer',
    'Wedding & Private Client',
    'Casting Agency',
    'Brand / Corporate',
    'NGO / Arts Foundation',
    'Government Institution',
    'Advertising Agency',
    'PR & Media Agency',
    'Talent Scout / Casting Team',
    'Festival / Cultural Organizer',
  ],
  'Institutes & Academies': [
    'Dance Academy',
    'Music School',
    'Art School',
    'Acting Institute',
    'Theatre Group',
    'Photography Institute',
    'Fine Arts Academy',
    'Cultural Center',
    'Coaching & Training Center',
  ],
  'Studios & Venues': [
    'Recording Studio',
    'Music Production Studio',
    'Podcast Studio',
    'Voice-over Studio',
    'Dubbing Studio',
    'Rehearsal Studio',
    'Dance Practice Studio',
    'Choreography Studio',
    'Rehearsal Space',
    'Photography Studio',
    'Videography Studio',
    'Green Screen Studio',
    'Film Shooting Studio',
    'Content Creator Studio',
    'Art Studio',
    'Sculpture Studio',
    'Craft Workshop',
    'Auditorium',
    'Amphitheatre',
    'Theatre Hall',
    'Concert Venue',
    'Banquet Hall',
    'Wedding Venue',
    'Convention Center',
    'Corporate Event Space',
    'Art Gallery',
    'Exhibition Hall',
    'Community Hall',
    'Clubhouse',
    'Open-Air Stage',
    'Workshop Venue',
    'Seminar Hall',
    'Training Center',
  ],
};

export const collaboratorCategoryNames = Object.keys(defaultCollaboratorCategoryOptions);

const slug = (value = '') =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const splitCommaValues = (value = '') =>
  String(value || '')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);

export const cleanStringList = (values = [], limit = 40) => {
  const cleaned = [];
  const seen = new Set();
  (Array.isArray(values) ? values : []).forEach((value) => {
    const item = String(value || '').trim();
    const key = item.toLowerCase();
    if (!item || seen.has(key)) return;
    cleaned.push(item);
    seen.add(key);
  });
  return cleaned.slice(0, limit);
};

export const mergeCollaboratorCategorySettings = (settings) => {
  const merged = Object.fromEntries(
    Object.entries(defaultCollaboratorCategoryOptions).map(([name, subcategories]) => [name, [...subcategories]])
  );
  const incoming = Array.isArray(settings?.categories) ? settings.categories : [];
  incoming.forEach((item) => {
    const name = String(item?.name || '').trim();
    if (!name) return;
    const existingName = Object.keys(merged).find((candidate) => slug(candidate) === slug(name));
    const targetName = existingName || name;
    merged[targetName] = cleanStringList([...(merged[targetName] || []), ...(item?.subcategories || [])]);
  });
  return merged;
};

export const getCollaboratorSubcategoryOptions = (categoryMap, mainCategory) =>
  Array.isArray(categoryMap?.[mainCategory]) ? categoryMap[mainCategory] : [];

export const inferCollaboratorMainCategory = (categoryMap, values = []) => {
  const normalizedValues = cleanStringList(values);
  for (const [mainCategory, subcategories] of Object.entries(categoryMap || {})) {
    if (normalizedValues.some((value) => subcategories.some((subcategory) => slug(subcategory) === slug(value)))) {
      return mainCategory;
    }
  }
  return '';
};

export const deriveCollaboratorOrganizationType = ({
  mainCategory = '',
  subcategories = [],
  otherText = '',
  fallback = '',
}) => {
  const parts = cleanStringList([...subcategories, otherText]);
  if (parts.length) return parts.join(', ');
  if (String(mainCategory || '').trim()) return String(mainCategory).trim();
  return String(fallback || '').trim();
};

export const toCollaboratorCategoryPayload = ({
  organization_category = '',
  organization_subcategories = [],
  organization_subcategory_other = '',
  organization_type = '',
}) => {
  const mainCategory = String(organization_category || '').trim();
  const subcategories = cleanStringList(organization_subcategories);
  const otherText = String(organization_subcategory_other || '').trim();
  return {
    organization_category: mainCategory || null,
    organization_subcategories: subcategories,
    organization_subcategory_other: otherText || null,
    organization_type: deriveCollaboratorOrganizationType({
      mainCategory,
      subcategories,
      otherText,
      fallback: organization_type,
    }),
  };
};
